import React from "react";
import './Footer2.css';
import Footer from './Footer';

function Footer2() {  // Renamed from App for component convention
  return (
    <footer className="footer">  {/* semantic <footer> tag */}
    <div>
      <div className="footer-column">
        <h3 className="contact-title">CONTACT:</h3>
        <p className="address-text">
          Link Road Number 3, Near Kali Mata Mandir, Bhopal, Madhya Pradesh, India 462003
        </p>
        <a href="tel:+919310346182" className="foot-href phone-link">
          📞 Telephone: +91 9310346182
        </a>
      </div>
      <br/>
      
      <div className="footer-column">
        <a href="mailto:techharsh2710@gmail.com" className="foot-href email-link">
          ✉️ Email: techharsh2710@gmail.com
        </a>
        <a href="https://www.manit.ac.in/" className="foot-href website-link">
          🌐 MANIT Bhopal
        </a>
      </div>
      </div>
      <Footer />
    </footer>
  );
}

export default Footer2;
